
// Import React hooks
import { useState } from "react";

// Import the close icon
import { CloseIcon } from "global/strich_icons/StrichIcons";

// Import the existing button component
import CreateButton from "global/components/CreateButton";

// Import tutorial styling
import "../css/Tutorial.css";

// Export the reusable tutorial popup
export default function TutorialLayout({
    title,
    description,
    minutes,
    steps,
    children,
    footer,
    setStep,

}) {

    // Track whether the popup is open
    const [isOpen, setIsOpen] = useState(false);

    // Display the tutorial button when closed
    if (!isOpen) {

        return (

            <CreateButton
                title="Tutorial"
                onClick={() => setIsOpen(true)}
            />

        );

    }

    // Render the tutorial popup
    return (

        <div className="popup-overlay">

            {/* Display the popup container */}
            <div
                className="popup-container popup-container--large"
                role="dialog"
                aria-modal="true"
                aria-label={title}
            >

                {/* Display the popup header */}
                <div className="popup__header">

                    {/* Display the popup title */}
                    <div className="popup__headerLeft">

                        <span className="tutorial__eyebrow">
                            STRICHSUITE GUIDES
                        </span>

                        <h2 className="popup__title">
                            {title}
                        </h2>

                        <div>

                        <p className="popup__subtitle">
                          {description}
                        </p>

                        {/* 
                        <div className="tutorial__metadata">

                            <span>Beginner friendly</span>

                            <span>About {minutes} minutes</span>

                            <span>{steps} steps</span>

                        </div>
                        */}
                        
                        </div>

                    </div>

                    {/* Display the popup actions */}
                    <div className="popup__headerRight">

                        {/* Close the tutorial */}
                        <button
                            type="button"
                            className="popup__close"
                            onClick={() => {

                                if (setStep) {

                                    // Reset the current step state
                                    setStep(1);

                                }

                                // Close the popup
                                setIsOpen(false);
                                
                            }}
                            title="Close tutorial"
                            aria-label="Close tutorial"
                        >

                            <CloseIcon />

                        </button>

                    </div>

                </div>

                {/* Display the popup content */}
                <div className="popup-content">

                    <main className="tutorial">

                        {/* Contain the tutorial content */}
                        <div className="tutorial__container">

                            {/* Display the tutorial introduction 
                            <header className="tutorial__hero">
                            

                            </header>
                            */}

                            {/* Display tutorial-specific content */}
                            {children}

                        </div>

                    </main>

                </div>

                {/* Footer actions */}
                <div className="tabs-footer tabs-footer--fill-no-background">
                    
                      {footer}
                                        
                </div>

            </div>

        </div>

    );

}
